import { UserCredential } from 'firebase/auth';

import {
  getUserDataFromFacebook,
  getUserDataFromGoogle,
  getUserEmailFromSocial,
} from 'components/BookingForm/utils/getOAuthData';
import { checkEmail } from 'services/APIs';
import { AUTH_SYS_TYPE, PROVIDER_ID } from 'utils/constants/common';

export const SOCIAL_LOGIN_ERROR_MESSAGE =
  'Something went wrong. Please try again later';

export const checkSocialEmail = async (
  userCredential: UserCredential,
  sysType: string
) => {
  const userToken = await userCredential.user.getIdToken();

  const providerId =
    sysType === AUTH_SYS_TYPE.GOOGLE
      ? PROVIDER_ID.GOOGLE
      : PROVIDER_ID.FACEBOOK;

  const email = getUserEmailFromSocial(userCredential, providerId);

  const { data } = await checkEmail(email);

  return { email, userToken, isExistingEmail: !!data?.isExistingEmail };
};

export const getSocialUserData = async (
  userCredential: UserCredential,
  sysType: string,
  userToken: string
) => {
  const userData =
    sysType === AUTH_SYS_TYPE.GOOGLE
      ? await getUserDataFromGoogle(userCredential)
      : await getUserDataFromFacebook(userCredential);

  return { ...userData, userToken };
};
